const colors = require("@mui/material/colors");
const { createTheme } = require("@mui/material/styles");

const defaultTheme = createTheme();

const fontFamily = "Lato, Helvetica Neue, sans-serif";
const fontWeight = 400;
const fontWeightBold = 800;
const headings = {
	fontFamily: "Lato, Helvetica Neue, Arial, sans-serif",
	fontWeight: 800,
	lineHeight: 1.3,
};

const typography = {
	fontFamily: "Lato, Helvetica Neue, Arial, sans-serif",
	fontWeight,
	fontWeightBold,
	body1: {
		fontSize: "1.05rem",
	},
	h1: {
		...headings,
	},
	h2: {
		...headings,
	},
	h3: {
		...headings,
	},
	h4: {
		...headings,
	},
	h5: {
		...headings,
	},
	h6: {
		...headings,
	},
	nav: {
		fontFamily: "Lato, Helvetica Neue, Arial, sans-serif",
		textTransform: "uppercase",
		color: "#ff6c0d",
		fontSize: "0.95em",
	},
  subnav: {
    fontWeight: 600,
  },
	toolsNav: {
		color: "#fea703",
		fontSize: "0.75em",
		fontWeight: 400,
	},
	brandTitle: {
		fontFamily: "Lato, Helvetica Neue, Arial, sans-serif",
	},
};

const grey = {
	50: "#fbfbfb",
	100: "#f5f5f5",
	200: "#eeeeee",
	300: "#e0e0e0",
	400: "#bdbdbd",
	500: "#9e9e9e",
	600: "#757575",
	700: "#616161",
	800: "#263238",
	900: "#212121",
};

const palette = {
	body: {
		light: "#fafafa",
	},
  subnav: {
    contrastText: "#757575",
    light: "#E9E9E9",
  },
	divider: "rgba(0, 0, 0, 0.12)",
	appBar: {
		public: {
			main: "#ffffff",
			light: "#ffffff",
			dark: "#ffffff",
			contrastText: "#fea703",
		},
	},
	secondary: {
		main: "#e05b27",
		dark: "#cc4f1f",
		contrastText: "#ffffff",
	},
	primary: {
		main: "#fea703",
		dark: "#de9100",
	},
	yellow: {
		main: "#ffa700",
	},
	orange: {
		main: "#ff6c0d",
	},
	red: {
		main: "#fea703",
	},
	grey: {
		...grey,
		lighter: grey["100"],
		light: grey["200"],
		main: grey["200"],
		dark: grey["300"],
		darker: grey["400"],
	},
	dark: {
		main: grey["800"],
		darker: grey["900"],
	},
	light: {
		main: grey["100"],
	},
	link: {
		main: "#ff6c0d",
		hover: "#e05b27",
	},
	titleBar: {
		public: {
			main: "#e05b27",
			dark: "#e05b27",
			contrastText: "#ffffff",
		},
	},
	footer: {
		main: grey["800"],
		contrastText: "#ffffff",
	},
	colophon: {
		main: grey["800"],
		contrastText: "#ffffff",
	},
  tab: {
    paper: "#EEEEEE",
		main: "#EEEEEE",
		hover: "#9e9e9e",
		contrastText: "#212121",
		contrastTextHover: "#ffffff",
  }
};

const themeConfig = {
	palette,
	components: {
		MuiAccordionSummary: {
			styleOverrides: {
				root: {
					"&:focus, &:active": {
						backgroundColor: grey["500"] + " !important",
					},
				},
			},
		},
	},
	typography,
	cloverleaf: {
		googleFont: "Lato:ital,wght@0,400;0,800;1,400;1,800",
    navbar: {
      align: "right",
      spacing: 1.4,
      padding: 0.75,
    },
		closingHeadingsStyled: false,
		footer: {
			disableFooterBrand: true,
		},
		brand: {
			size: 92,
      paddingTop: 0.75,
      paddingTop: 0.75,
		},
		css: `

      @media (min-width: 1199.96px) {
        #___gatsby .tools-nav {
          position: relative;
        }
        #___gatsby .tools-nav::after {
          content: '';
          position: absolute;
          bottom: -0.25rem;
          right: 0;
          width: 100%;
          height: 1px;
          background-image: linear-gradient(90deg, hsla(0, 0%, 100%, 0.52) 28%, rgba(33, 63, 101, 0.21));
        }
      }
		`,
	},
};
module.exports = themeConfig;
